import Navbar from "./components/Navbar";
import HeroBanner from "./components/HeroBanner";
import EventInfo from "./components/EventInfo";
import Schedule from "./components/Schedule";
import MindModalities from "./components/MindModalities";
import BodyModalities from "./components/BodyModalities";
import AdditionalInfo from "./components/AdditionalInfo";
import FinalBanner from "./components/FinalBanner";
import SeoJsonLd from "../../components/feature/SeoJsonLd";

export default function Home() {
  return (
    <main className="min-h-screen bg-white font-sans">
      <SeoJsonLd />
      <Navbar />
      <HeroBanner />
      <EventInfo />
      <Schedule />
      <MindModalities />
      <BodyModalities />
      <AdditionalInfo />
      <FinalBanner />
    </main>
  );
}
